import { render, staticRenderFns } from "./CamSlot.vue?vue&type=template&id=a2165bc0"
import script from "./CamSlot.vue?vue&type=script&lang=js"
export * from "./CamSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports